export const ScreenConfigurationDeleteReasonEnum = Object.freeze({
  HAS_ACTIVE_INFO_MESSAGES: "HAS_ACTIVE_INFO_MESSAGES",
  HAS_CHILD_CONFIGURATIONS: "HAS_CHILD_CONFIGURATIONS"
});
